import { Grid, GridItem, GridRow } from '../../Grid';
import { WavyCircleIcon } from '@icons/WavyCircle';
import { Title } from '../../Typography';
import { IHits } from '../index';
import { NextLink } from '../../NextLink';

interface ISearchResults {
  hits?: IHits[];
  clickPopularSearch?: (item: IHits, index: number) => void;
  onItemClick?: () => void;
}

export const SearchResults = ({ hits, clickPopularSearch, onItemClick }: ISearchResults) => {
  return hits?.map((hit: IHits, index: number) => (
    <div className="group hover:bg-[#E8EBE8]" key={hit.query ?? `search-list-${index}`}>
      <NextLink
        href={`/search?query=${hit.query}`}
        onClick={() => {
          if (clickPopularSearch) {
            clickPopularSearch(hit, index);
          }
          if (onItemClick) {
            onItemClick();
          }
        }}
      >
        <Grid>
          <GridRow columns={16} className="-mt-5">
            <GridItem
              colSpan={12}
              colStart={3}
              className="flex border-heroCurve border-b py-5 popular-list group-hover:pb-[19px]"
            >
              <div className="relative mr-3 w-7 md:mr-10 md:w-34">
                <WavyCircleIcon />
                <Title
                  className="absolute -inset-0 flex items-center justify-center"
                  tag="h3"
                  type="xxxs"
                >
                  {index + 1}
                </Title>
              </div>
              <div>
                <Title
                  tag="h3"
                  type="xs"
                  className="search-title inline-block first-letter:uppercase group-hover:font-semibold group-hover:border-b group-hover:border-black"
                >
                  {hit.query}
                </Title>
              </div>
            </GridItem>
          </GridRow>
        </Grid>
      </NextLink>
    </div>
  ));
};
